import MyTabs from '../../components/MyTabs';
import Section1 from './Section1/Section1';
import Section2 from './Section2/Section2';
import Section3 from './Section3/Section3';
import Section5 from './Section5/Section5';
import ResearchCategories from './ResearchCategories/ResearchCategories';
import Keywords from './Keywords/Keywords';
import { useParams } from 'react-router-dom';

const GeneralVideos = () => {

    const { alias } = useParams();
    const isTabDisabled = alias ? false : true;

    const tabs = [
        { id: "section1", title: "Section-1", Component: Section1  },
        { id: "section2", title: "Section-2", Component: Section2, isDisabled: isTabDisabled },
        { id: "section3", title: "Section-3", Component: Section3, isDisabled: isTabDisabled },
        { id: "section5", title: "Section-5", Component: Section5, isDisabled: isTabDisabled },
        { id: "researchCategories", title: "Research Categories", Component: ResearchCategories, isDisabled: isTabDisabled },
        { id: "keywords", title: "Keywords", Component: Keywords, isDisabled: isTabDisabled },
      ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralVideos;